var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUPolygon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#09F",
  d: "m27.338 14.374-5.625-9.737a1.25 1.25 0 0 0-1.088-.625H9.375a1.25 1.25 0 0 0-1.087.625l-5.625 9.737a1.25 1.25 0 0 0 0 1.25l5.625 9.738a1.25 1.25 0 0 0 1.087.625h11.25a1.25 1.25 0 0 0 1.088-.625l5.625-9.738a1.25 1.25 0 0 0 0-1.25m-7.5 9.113H10.1l-4.912-8.488L10.1 6.512h9.8l4.913 8.487z"
})));
export default SvgUPolygon;